package com.example.hukakmp.viewmodel

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.example.hukakmp.data.AiQuotaRepository
import com.example.hukakmp.identification.FishIdentification
import com.example.hukakmp.identification.FishIdentificationResult
import com.example.hukakmp.identification.identifyFishPhoto
import com.example.hukakmp.model.FotoSeleccionada
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

class FishIdentificationViewModel(
    private val quotaRepository: AiQuotaRepository,
) : ViewModel() {

    data class UiState(
        val photo: FotoSeleccionada? = null,
        val isAnalyzing: Boolean = false,
        val result: FishIdentification? = null,
        val error: String? = null,
        val photosRemaining: Int = 1,
        val photosTotal: Int = 1,
    )

    private val _uiState = MutableStateFlow(UiState())
    val uiState: StateFlow<UiState> = _uiState.asStateFlow()

    init {
        refreshQuota()
    }

    fun refreshQuota() {
        viewModelScope.launch {
            val quota = quotaRepository.getState()
            _uiState.value = _uiState.value.copy(
                photosRemaining = quota.photosRemaining,
                photosTotal = quota.photosTotal,
            )
        }
    }

    fun analyze(photo: FotoSeleccionada) {
        viewModelScope.launch {
            val quota = quotaRepository.getState()
            if (quota.photosRemaining <= 0) {
                _uiState.value = _uiState.value.copy(
                    photo = photo,
                    isAnalyzing = false,
                    result = null,
                    error = "Ya usaste tu identificación con IA de hoy. Se renueva al comenzar un nuevo día.",
                    photosRemaining = 0,
                    photosTotal = quota.photosTotal,
                )
                return@launch
            }

            _uiState.value = UiState(
                photo = photo,
                isAnalyzing = true,
                photosRemaining = quota.photosRemaining,
                photosTotal = quota.photosTotal,
            )

            when (
                val result = identifyFishPhoto(
                    bytes = photo.bytes,
                    contentType = photo.contentType,
                )
            ) {
                is FishIdentificationResult.Success -> {
                    val consumed = quotaRepository.consumePhoto()
                    _uiState.value = UiState(
                        photo = photo,
                        result = result.identification,
                        photosRemaining = consumed?.photosRemaining
                            ?: quota.photosRemaining,
                        photosTotal = consumed?.photosTotal
                            ?: quota.photosTotal,
                    )
                }

                is FishIdentificationResult.Error -> {
                    _uiState.value = UiState(
                        photo = photo,
                        error = result.message,
                        photosRemaining = quota.photosRemaining,
                        photosTotal = quota.photosTotal,
                    )
                }
            }
        }
    }

    fun clear() {
        val quota = _uiState.value
        _uiState.value = UiState(
            photosRemaining = quota.photosRemaining,
            photosTotal = quota.photosTotal,
        )
    }

    fun retry() {
        _uiState.value.photo?.let(::analyze)
    }
}
